import DTO from './DTO';
import { required } from '../utils/validation';

class InsurerDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'insurer',
        type: String,
        validators: [],
        labelKey: 'insurer',
      },
      {
        name: 'insurance_contract_series',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_series',
      },
      {
        name: 'insurance_contract_number',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_number',
      },
      {
        name: 'insurance_contract_effective_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_effective_date',
      },
      {
        name: 'insurance_contract_expiration_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_expiration_date',
      },
      {
        name: 'osgop_files',
        type: String,
        validators: [required],
        labelKey: 'media.osgop_files',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default InsurerDTO;
